@if (isOpen()) {
  <div
    class="
      fixed inset-0 bg-black/50 backdrop-blur-[1px] 
      flex items-center justify-center p-4 animate-fade-in
      md:px-0
      max-h-[calc(100vh)]!
    "
    [style.z-index]="zIndex"
    (click)="onBackdropClick($event)"
  >
    <div
      class="bg-white rounded-lg shadow-xl w-full animate-slide-up"
      [class]="maxWidthClass()"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'modal-title'"
    >
      <!-- header -->
       @if (withHeader()) {
        <div class="flex items-start justify-between bg-secondary/20 p-6 py-4 border-b border-border-2">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-2xl! text-secondary">{{ icon() }}</span>
          <span class="text-heading-primary font-semibold font-heading text-lg">{{ title() }}</span>
        </div>
        <button
          type="button"
          class="text-secondary hover:text-heading-primary transition-colors"
          (click)="onClose()"
          aria-label="Cerrar"
        >
          <span class="material-symbols-outlined text-2xl">close</span>
        </button>
        </div>
      }
      <!-- body -->
      <div class="p-6 py-8 max-h-[calc(100vh-160px)]! overflow-y-auto relative"
        [class.p-0!]="noSpacing()"
        [class.py-0!]="noSpacing()"
      >
        @if(!withHeader()) {
          <button
            type="button"
            class="text-secondary hover:text-heading-primary transition-colors
              absolute
            "
            [ngClass]="btnClass()"
            (click)="onClose()"
            aria-label="Cerrar"
          >
            <span class="material-symbols-outlined text-2xl">close</span>
          </button>
        }
        <ng-content></ng-content>
      </div>
      <!-- footer -->
      @if (withFooter()) {
        <div class="flex justify-center gap-3 p-6 py-3 border-t border-border-2">
          
        </div>
      }
    </div>
  </div>
}